export const GET_DATA = 'COUNTRIES/GET_DATA'
export const SET_DATA = 'COUNTRIES/SET_DATA'
export const RESET_DATA = 'COUNTRIES/RESET_DATA'
